<template>
  <b-card no-body>
    <h6 class="title">{{ info.name }}</h6>
    <b-row no-gutters class="info">
      <item-card
        :title="translate.result.cardReseller.supervisor + ':'"
        :text="info.responsible"
      />
      <item-card
        :title="translate.result.cardReseller.phone + ':'"
        :text="info.cellphone"
      />
    </b-row>
    <button-component
      :href="`tel:${info.cellphone}`"
      :label="translate.result.cardReseller.call"
      icon="telephone"
    />
  </b-card>
</template>

<script>
import ItemCard from './ItemCard.vue';
import ButtonComponent from '../Button.vue';

export default {
  name: 'supervisor-card',
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  components: {
    ItemCard,
    ButtonComponent,
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>
<style lang="scss" scoped>
.info {
  display: flex;
  flex-direction: column;
}

.title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 1rem;
}

.card {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  width: 100%;
  max-width: 420px;
  font-size: 12px;
  margin-bottom: 10px;
  border: 1px solid #dfe0e0;
  border-radius: 5px;
  background: #fff;
}
</style>
